<script lang="ts">
	import { page } from "$app/state";
	import ListProducts from "#lib/ListProducts.svelte";
	import MetaData from "#lib/MetaData.svelte";
	import { selectedSort, sortProducts } from "../../sortState.svelte";

	const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);
	let { data } = $props();
	let categoryProducts = $derived(sortProducts(data?.products, selectedSort.sort));
	let category = $derived(capitalize(page.params.category || ""));
</script>

<MetaData
	data={{
		title: `${category || "Smarte produkter"} i nettbutikken`,
		description: `${category || "Smarte produkter"} i Ishavskrafts nettbutikk. Finn smarte løsninger som gjør strøm enklere.`,
	}}
/>

{#if categoryProducts}
	<ListProducts products={categoryProducts} />
{/if}
